import { useCallback } from "react";
import { AdState, AutoPlayStatus, PromoState } from "../../../globals";
import { removeSubtitles } from "./utils";

export const useResetVideoState = ({
  autoplayState,
  resetControlsState,
  setAdState,
  updateAutoplayState,
  adState,
  removeHLS,
  videoElementRef,
  closeStickyPlayer,
  isOpenSticky,
  setIsFullscreen,
  setRenderControls,
  setPromoState,
  isFullscreen
}) => {
  // Reset player
  const resetVideoState = useCallback(
    hasNextVideo => {
      // Set ad state to INIT if it's not in ERROR state
      if (adState !== AdState.ERROR) {
        setAdState(AdState.INIT);
      }

      // Reset various states
      setRenderControls(false);
      setPromoState(PromoState.READY);
      resetControlsState();

      // Update autoplay state
      updateAutoplayState({
        isPlaythrough: hasNextVideo,
        status: autoplayState?.status ? AutoPlayStatus.COMPLETE : null
      });

      // Remove HLS and subtitles
      removeHLS();
      removeSubtitles(videoElementRef.current);

      // Close sticky player if open
      if (!hasNextVideo && isOpenSticky) {
        closeStickyPlayer();
      }

      // Exit fullscreen mode
      if (isFullscreen) {
        setIsFullscreen(false);
      }
    },
    [
      autoplayState?.status,
      adState,
      setAdState,
      setRenderControls,
      setPromoState,
      resetControlsState,
      updateAutoplayState,
      removeHLS,
      videoElementRef,
      isOpenSticky,
      closeStickyPlayer,
      setIsFullscreen,
      isFullscreen
    ]
  );

  return resetVideoState;
};
